import { cancel, delaySound, Waiter } from "common/promises";
class StepChangedListen {
    constructor(heartBeatSound) {
        this.heartBeatSound = heartBeatSound;
    }
    stepChanged(step) {
        this.heartBeatSound.stepChange(step);
    }
}
export class HeartBeatSound {
    constructor(sound) {
        this.step = 1;
        this.stepChanged = new Waiter();
        this.playing = null;
        this.stepChangedListener = new StepChangedListen(this);
        this.sound = sound;
    }
    play() {
        this.playing = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                switch (this.step) {
                    case 1:
                        await this.play1(canceler);
                        break;
                    case 2:
                        await this.play2(canceler);
                        break;
                    case 3:
                        await this.play3(canceler);
                        break;
                    case 4:
                        await this.play4(canceler);
                        break;
                    case 5:
                        await this.play5(canceler);
                        break;
                }
            }
        });
    }
    async play1(canceler) {
        while (true) {
            canceler.check();
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            await this.sound.awaitPlay("heartBeat1", { volume: 0.5 });
        }
    }
    async play2(canceler) {
        while (true) {
            canceler.check();
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            await this.sound.awaitPlay("heartBeat2", { volume: 0.6 });
            canceler.check();
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            await this.sound.awaitPlay("heartBeat2", { volume: 0.6 });
            await delaySound(500);
        }
    }
    async play3(canceler) {
        while (true) {
            canceler.check();
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            await this.sound.awaitPlay("heartBeat2", { volume: 0.8 });
        }
    }
    async play4(canceler) {
        while (true) {
            canceler.check();
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            await this.sound.awaitPlay("heartBeat3", { volume: 1 });
        }
    }
    async play5(canceler) {
        while (true) {
            canceler.check();
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            await this.sound.awaitPlay("heartBeat3", { volume: 1 });
        }
    }
    stepChange(step) {
        this.step = step;
        this.stepChanged.trigger();
    }
}
//# sourceMappingURL=heartBeatSound.js.map